var SupportRedemptionInstructionsPopupView, SupportRedemptionInstructionsServiceActionView, SupportServiceActionButtonTemplate, SupportServiceActionsBaseView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportRedemptionInstructionsPopupView = require('../redemption_instructions_popup_view');

SupportServiceActionsBaseView = require('./service_action_base');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportRedemptionInstructionsServiceActionView = (function(superClass) {
  extend(SupportRedemptionInstructionsServiceActionView, superClass);

  function SupportRedemptionInstructionsServiceActionView() {
    return SupportRedemptionInstructionsServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportRedemptionInstructionsServiceActionView.prototype.id = 'id_redemption_instruction';

  SupportRedemptionInstructionsServiceActionView.prototype.initialize = function(options) {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    return this.order = Groupon.Support.currentOrder;
  };

  SupportRedemptionInstructionsServiceActionView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportRedemptionInstructionsServiceActionView.prototype.toHash = function() {
    var hash;
    hash = {
      service_action_id: "redemption_instruction",
      service_action: I18n.t("js.modules.support.view_redemption_instructions")
    };
    return this.extendHash(hash);
  };

  SupportRedemptionInstructionsServiceActionView.prototype.actionHandler = function(event) {
    var current_order;
    current_order = Groupon.Support.currentOrder;
    this.popup = new SupportRedemptionInstructionsPopupView();
    return this.popup.render();
  };

  SupportRedemptionInstructionsServiceActionView.prototype.events = {
    "click #redemption_instruction": "actionHandler"
  };

  return SupportRedemptionInstructionsServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportRedemptionInstructionsServiceActionView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvb3JkZXJfcmVsYXRlZC9zZXJ2aWNlX2FjdGlvbnMvcmVkZW1wdGlvbl9pbnN0cnVjdGlvbnNfc2VydmljZV9hY3Rpb24uY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvb3JkZXJfcmVsYXRlZC9zZXJ2aWNlX2FjdGlvbnMvcmVkZW1wdGlvbl9pbnN0cnVjdGlvbnNfc2VydmljZV9hY3Rpb24uY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEseUpBQUE7RUFBQTs7O0FBQUEsc0NBQUEsR0FBeUMsT0FBQSxDQUFRLHVDQUFSOztBQUN6Qyw2QkFBQSxHQUFnQyxPQUFBLENBQVEsdUJBQVI7O0FBQ2hDLGtDQUFBLEdBQXFDLE9BQUEsQ0FBUSxpREFBUjs7QUFFL0I7Ozs7Ozs7MkRBQ0osRUFBQSxHQUFJOzsyREFFSixVQUFBLEdBQVksU0FBQyxPQUFEO0lBQ1YsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxLQUFWLENBQWdCLENBQWhCLEVBQW1CLENBQUMsSUFBRCxDQUFNLENBQUMsTUFBUCxDQUFjLENBQUMsQ0FBQyxTQUFGLENBQVksSUFBWixDQUFkLENBQW5CO0lBQ0EsSUFBQyxDQUFBLFNBQUQsR0FBYTtJQUNiLElBQUMsQ0FBQSxRQUFELEdBQVk7V0FDWixJQUFDLENBQUEsS0FBRCxHQUFTLE9BQU8sQ0FBQyxPQUFPLENBQUM7RUFKZjs7MkRBTVosTUFBQSxHQUFRLFNBQUE7V0FDTixJQUFDLENBQUEsR0FBRyxDQUFDLE1BQUwsQ0FBWSxNQUFBLENBQU8sSUFBQyxDQUFBLFFBQVIsRUFBa0IsSUFBQyxDQUFBLE1BQUQsQ0FBQSxDQUFsQixFQUE2QixJQUFDLENBQUEsU0FBOUIsQ0FBWjtFQURNOzsyREFHUixNQUFBLEdBQVEsU0FBQTtBQUNOLFFBQUE7SUFBQSxJQUFBLEdBQ0U7TUFBQSxpQkFBQSxFQUFvQix3QkFBcEI7TUFDQSxjQUFBLEVBQWlCLElBQUksQ0FBQyxDQUFMLENBQU8saURBQVAsQ0FEakI7O1dBRUYsSUFBQyxDQUFBLFVBQUQsQ0FBWSxJQUFaO0VBSk07OzJEQU1SLGFBQUEsR0FBZSxTQUFDLEtBQUQ7QUFDYixRQUFBO0lBQUEsYUFBQSxHQUFnQixPQUFPLENBQUMsT0FBTyxDQUFDO0lBRWhDLElBQUMsQ0FBQSxLQUFELEdBQVMsSUFBSSxzQ0FBSixDQUFBO1dBQ1QsSUFBQyxDQUFBLEtBQUssQ0FBQyxNQUFQLENBQUE7RUFKYTs7MkRBTWYsTUFBQSxHQUNFO0lBQUEsK0JBQUEsRUFBbUMsZUFBbkM7Ozs7O0dBekJ5RDs7QUEyQjdELE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
